import DOMPurify from 'dompurify';
import { htmlDecode } from './htmlDecode';

const DEFAULT_FORBID_CONTENTS_MINUS_STYLE = [
  'annotation-xml',
  'audio',
  'colgroup',
  'desc',
  'foreignobject',
  'head',
  'iframe',
  'math',
  'mi',
  'mn',
  'mo',
  'ms',
  'mtext',
  'noembed',
  'noframes',
  'noscript',
  'plaintext',
  'script',
  'svg',
  'template',
  'thead',
  'title',
  'video',
  'xmp'
];

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(htmlDecode(html), {
    FORCE_BODY: true,
    FORBID_CONTENTS: DEFAULT_FORBID_CONTENTS_MINUS_STYLE,
    ALLOW_DATA_ATTR: true
  });
}
